import { useTranslation } from 'react-i18next';
import {
  IconTile,
  Button,
  InputTextarea,
  InputText,
  Tag,
} from '@teo/components';
import { Training, Evaluation, Document } from '@teo/components/icons';
import { useEffect, useState, useRef } from 'react';
import InfoSection from '@/components/InfoSection';
import UploadDropzoneSection from '@/components/UploadDropzoneSection/UploadDropzoneSection';
import { uploadImage, uploadFile } from '@/query/documents';

const CorrectionTrainingContent = ({
  training,
  followTraining,
  studentId,
  setRemarks,
  remarks,
  setPass,
  pass,
  setScore,
  score,
  setCertificate,
  certificate,
}) => {
  const { t } = useTranslation();
  const [editScore, setEditScore] = useState(false);
  const fileInputRef = useRef(null);

  let type = null;
  let name = null;

  if (certificate) {
    const fullFileName = certificate.substring(
      certificate.lastIndexOf('/') + 1
    );
    type = fullFileName.substring(fullFileName.lastIndexOf('.') + 1);

    name = fullFileName.substring(0, fullFileName.lastIndexOf('.'));
  }

  const handleUploadPhoto = async (event) => {
    const file = event.target.files[0];
    const size = 900;
    const data = file?.type.includes('pdf')
      ? await uploadFile('upload/', file)
      : await uploadImage(file, size, size);
    setCertificate(data);
  };

  return (
    <div className="flex w-full">
      <div className="mx-auto flex w-full max-w-xl flex-col gap-6 py-8 px-4">
        <div className="flex items-center gap-3">
          <div>
            <IconTile
              Icon={
                training?.trainingType === 'evaluation' ? Evaluation : Training
              }
              color={
                training?.trainingType === 'evaluation' ? 'purple' : 'green'
              }
              size="small_md"
            />
          </div>

          <div>
            <p className="text-sm text-grey-05">
              {training?.typeOfTraining === 'external'
                ? training?.trainingType === 'evaluation'
                  ? t('pages.landing_training.external_e')
                  : t('pages.landing_training.external_t')
                : training?.typeOfTraining === 'internal'
                ? training?.trainingType === 'evaluation'
                  ? t('pages.landing_training.internal_e')
                  : t('pages.landing_training.internal_t')
                : t('pages.landing_training.online_t')}
            </p>
            <p className={`text-base font-semibold text-black`}>
              {training?.trainingName}
            </p>
          </div>
        </div>
        {training?.inputScore &&
          training?.uploadCertificate &&
          (training?.inputScoreType === 'studentOrEvaluator' ||
            training?.inputScoreType === 'student') && (
            <div>
              <InfoSection
                text={t(
                  'pages.lp_training_correction.message_score_certificate'
                )}
              />
            </div>
          )}
        {training?.inputScore &&
          !training?.uploadCertificate &&
          (training?.inputScoreType === 'studentOrEvaluator' ||
            training?.inputScoreType === 'student') && (
            <div>
              <InfoSection
                text={t('pages.lp_training_correction.message_score')}
              />
            </div>
          )}
        {!training?.inputScore && training?.uploadCertificate && (
          <div>
            <InfoSection
              text={t('pages.lp_training_correction.message_certificate')}
            />
          </div>
        )}
        <div className="flex w-full flex-col">
          <h3 className="pb-1 text-base font-semibold text-black">
            {t('pages.landing_training.results')}
          </h3>
          {!training?.inputScore && !training?.uploadCertificate && (
            <p className="text-sm text-grey-07">
              {t('pages.lp_training_correction.indicate_tr', {
                type: t(`pages.lp_landing.${training?.trainingType}`),
              })}
            </p>
          )}
          {!training?.inputScore && training?.uploadCertificate && (
            <p className="text-sm text-grey-07">
              {t('pages.lp_training_correction.validate_certificate_message')}
            </p>
          )}
          {training?.inputScore &&
            training?.uploadCertificate &&
            training?.inputScoreType === 'evaluator' && (
              <p className="text-sm text-grey-07">
                {t(
                  'pages.lp_training_correction.enter_score_certificate_message'
                )}
              </p>
            )}
          {training?.inputScore &&
            !training?.uploadCertificate &&
            training?.inputScoreType === 'evaluator' && (
              <p className="text-sm text-grey-07">
                {t('pages.lp_training_correction.enter_score_message')}
              </p>
            )}

          {training?.inputScore &&
            !training?.uploadCertificate &&
            training?.inputScoreType !== 'evaluator' && (
              <p className="text-sm text-grey-07">
                {t('pages.lp_training_correction.validate_score_message')}
              </p>
            )}
          {training?.inputScore &&
            training?.uploadCertificate &&
            training?.inputScoreType !== 'evaluator' && (
              <p className="text-sm text-grey-07">
                {t(
                  'pages.lp_training_correction.validate_score_certificate_message'
                )}
              </p>
            )}
        </div>
        {}
        {!training?.inputScore && !training?.uploadCertificate && (
          <div className="flex flex-row gap-2">
            <Button
              className={`flex basis-1/2 items-center border text-sm shadow-none ${
                pass === 'not_pass' ? 'border-secondary-04' : ''
              }`}
              onClick={() => {
                setPass('not_pass');
              }}
              variant="outline"
              size="lg"
            >
              <img
                src="/images/icons/notpass.svg"
                alt="not passed
                        "
                className="mr-3 w-5"
              />
              {t('pages.lp_training_correction.not_pass', {
                type: t(`pages.lp_landing.${training?.trainingType}`),
              })}
            </Button>
            <Button
              className={`flex basis-1/2 items-center border text-sm shadow-none ${
                pass === 'pass' ? 'border-secondary-04' : ''
              }`}
              onClick={() => {
                setPass('pass');
              }}
              variant="outline"
              size="lg"
            >
              <img
                src="/images/icons/pass.svg"
                alt="passed
                        "
                className="mr-3 w-5"
              />
              {t('pages.lp_training_correction.passed', {
                type: t(`pages.lp_landing.${training?.trainingType}`),
              })}
            </Button>
          </div>
        )}
        {training?.inputScore && (
          <div>
            <div className="flex w-full flex-col">
              <h4 className="mb-1 text-sm font-semibold text-black">
                {t('columns.score')}
              </h4>
              <div className="flex flex-row gap-2">
                <div className=" w-max">
                  <InputText
                    disabled={
                      !editScore && training?.inputScoreType !== 'evaluator'
                    }
                    type="number"
                    style={{ width: '140px' }}
                    value={score}
                    onChange={(ev) => {
                      const sc = ev.target.value;
                      +sc < 101 && setScore(ev.target.value);
                    }}
                    suffix="%"
                  />
                </div>
                {training?.inputScoreType !== 'evaluator' && (
                  <Button variant="outline" onClick={() => setEditScore(true)}>
                    {t('pages.lp_training_correction.edit_score')}
                  </Button>
                )}
              </div>
            </div>
            <div className="mt-2 text-sm text-grey-05">
              {t('pages.course_content_flow.step_3.minimum_score')} -{' '}
              {Math.round(training?.minScore * 100)}%
            </div>
          </div>
        )}
        <div className="flex w-full flex-col">
          <h4 className="mb-1 text-sm font-semibold text-black">
            {t('pages.lp_training_correction.remarks')}
          </h4>
          <div>
            <InputTextarea
              id="remarks"
              placeholder={t(`pages.lp_training_correction.type_remarks`)}
              onChange={(ev) => setRemarks(ev.target.value)}
              value={remarks}
            />
          </div>
        </div>
        {training?.uploadCertificate && (
          <div className="flex w-full flex-col">
            <h4 className="mb-1 text-sm font-semibold text-black">
              {t('pages.landing_training.upload_certificate')}
            </h4>
            {certificate ? (
              <>
                <div className="flex items-center justify-between rounded-lg border border-[#eaeaed] p-3">
                  <div className="flex items-center">
                    {certificate.includes('.pdf') ? (
                      <a
                        href={certificate}
                        target="_blank"
                        rel="noreferrer"
                        className="mr-3 flex h-16 w-16 rounded border border-error-02 bg-error-01 text-error-05"
                      >
                        <Document className="m-auto w-10" />
                      </a>
                    ) : (
                      <img
                        alt="logo"
                        src={certificate}
                        className={`mr-3 h-16 flex-[1_0_64px] rounded object-cover object-center`}
                      />
                    )}
                    <div>
                      <p
                        className={`
                          overflow-hidden
                          truncate
                          text-base
                          font-semibold
                        `}
                      >
                        {name}
                      </p>
                      {certificate.includes('.pdf') ? (
                        <Tag
                          documentType="PDF"
                          title="PDF"
                          variant="document"
                        />
                      ) : (
                        <Tag
                          title={`${type}`}
                          size="md"
                          variant="document"
                          documentType="image"
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-3 flex gap-3">
                  <Button
                    variant="outline"
                    onClick={() => {
                      fileInputRef.current?.click();
                    }}
                  >
                    {t(`pages.lp_training_correction.replace_file`)}
                  </Button>
                  <Button
                    className="!text-error-04"
                    variant="ghost"
                    onClick={() => setCertificate(null)}
                  >
                    {t(`pages.lp_training_correction.delete_file`)}
                  </Button>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleUploadPhoto}
                    accept="image/*,application/pdf"
                    style={{ display: 'none' }}
                    multiple={false}
                  />
                </div>
              </>
            ) : (
              <UploadDropzoneSection
                setUploadLogo={setCertificate}
                // uploadLogo={certificate}
                onlyFile={true}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default CorrectionTrainingContent;
